import { Block } from "@mui/icons-material";
import { TextField, Button } from "@mui/material";
import axios from "axios";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';

function EditPeer(props)
{
    const editPeer=()=>
    {
        console.log(props.selectedPeer);
        //Send the peer out to save changes - just the name
        axios({
            // Endpoint to send files
            url: process.env.REACT_APP_API_URL+'PeerGroup',
            method: "PUT",
            data:{ peerGroupId:props.selectedPeer.peerGroupId,
                    peerName:props.selectedPeer.peerName,
                    isActive: props.selectedPeer.isActive,
                    division: props.selectedPeer.division
             },
            headers: {
                // Add any auth token here
                //authorization: "your token comes here",
            },
        }).then((res) => {            
            props.setSelectedPeerGroupId(0);
            props.refreshPeers();
        }).catch((err) => {
            console.log(err)
        });
    };
    const cancelPeer=()=>
    {
        props.setSelectedPeerGroupId(0);
    }

    const toggleActive = () => {
        const updatedPeer = {
            ...props.selectedPeer,
            isActive: !props.selectedPeer.isActive
        };
        props.setSelectedPeer(updatedPeer);
    };

    if(props.selectedPeer)
    {
    return(
        <>
            <div className='formGroup'>
                
            </div>
            <div className='formGroup'>
            <TextField className="formControl" id="standard-basic" label="Edit Name" variant="outlined" onChange={(e)=>props.setSelectedPeer({...props.selectedPeer,peerName:e.target.value})} value={props.selectedPeer.peerName} />
            <div className="formRow">
                <div className="formGroup">
                    <Button 
                        startIcon={props.selectedPeer.isActive ? <DeleteIcon /> : <RestoreFromTrashIcon />} 
                        variant="outlined" 
                        size="small" 
                        onClick={toggleActive} 
                        sx={{ml:2}}
                    >
                        {props.selectedPeer.isActive ? 'Disable' : 'Enable'}
                    </Button>
                    <Button 
                        startIcon={<CheckIcon />} 
                        variant="outlined" 
                        size="small" 
                        onClick={editPeer} 
                        sx={{ml:2}}
                    >
                        Save
                    </Button>
                    <Button 
                        startIcon={<CloseIcon />} 
                        variant="outlined" 
                        size="small" 
                        onClick={cancelPeer} 
                        sx={{ml:2}} 
                    >
                        Cancel
                    </Button>
                </div>
            </div>            
            </div>
            <div className='formGroup'>
            
        </div>
        </>
    );
    }
    else{
        return(<></>);

    }
}


export default EditPeer;